import common from "../common";
import GelHackButton from "../ui/gel/GelHackButton";
import GelScene from "../ui/gel/GelScene";
import Achievement from "../Achievement";
import AchievementSystem from "../AchievementSystem";

export default class LootCrateScene extends GelScene {
    constructor(item, showItem, showOrb) {
        super();

        this._item = item;
        this._showItem = showItem;
        this._showOrb = showOrb;

        this._overlay = null;
        this._glow = null;
        this._image = null;
        this._orb = null;
        this._weapon = null;
        this._crate = null;
        this._panel = null;
        this._confirmButton = null;
        this._declineButton = null;

        this._particleLayer = null;
        this._coinEmitter = null;

        this._bindings = {};
        this._imageLoaded = false;

        this._equipmentAchievement = common.equipmentAchievement;
        common.equipmentAchievement = -1;

        console.log(this._item);
    }

    init() {
        super.init();

        this._overlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._overlay.height = P3.View.height;
        this._overlay.alpha = 0.7;
        this._overlay.tint = 0x0;
        this._overlay.visible = false;
        this.addChild(this._overlay);

        this._glow = new PIXI.Sprite(P3.assets.texture("ui_results_loot_glow"));
        this._glow.position.set(common.STAGE_WIDTH * 0.5, P3.View.height * 0.5);
        this._glow.scale.set(4);
        this._glow.anchor.set(0.5);
        this._glow.visible = false;
        this.addChild(this._glow);

        this._glow.additive = new PIXI.Sprite(P3.assets.texture("ui_results_loot_glow"));
        this._glow.additive.anchor.set(0.5);
        this._glow.additive.blendMode = PIXI.BLEND_MODES.ADD;
        this._glow.additive.alpha = 0;
        this._glow.addChild(this._glow.additive);

        this._particleLayer = new PIXI.Container();
        this.addChild(this._particleLayer);

        this._image = new PIXI.Sprite(P3.assets.texture("coins_1"));
        this._image.position.set(common.STAGE_WIDTH * 0.5, 300);
        this._image.anchor.set(0.5);
        this._image.visible = false;
        this.addChild(this._image);

        this._orb = new PIXI.Container();
        this._orb.position.set(common.STAGE_WIDTH * 0.5, 300);
        this._orb.visible = false;
        this.addChild(this._orb);

        this._orb.back = new PIXI.Sprite(P3.assets.texture("orb_base"));
        this._orb.back.anchor.set(0.5);
        this._orb.addChild(this._orb.back);

        this._orb.front = new PIXI.Sprite(P3.assets.texture("orb_base"));
        this._orb.front.alpha = 0.1;
        this._orb.front.anchor.set(0.5);
        this._orb.front.blendMode = PIXI.BLEND_MODES.ADD;
        this._orb.addChild(this._orb.front);

        let config = P3.assets.json("particle_orb_big");
        this._orb.emitter = new PIXI.particles.Emitter(this._particleLayer, [
            P3.assets.texture("particle_orb"),
        ], config);
        this._orb.emitter.updateOwnerPos(this._orb.x, this._orb.y);
        this._orb.emitter.emit = false;

        this._weapon = new PIXI.Sprite(P3.assets.texture("guardians/" + common.character.group + "/" + common.character.skin + "/tool_golden"));
        this._weapon.position.set(common.STAGE_WIDTH * 0.5, 300);
        this._weapon.anchor.set(0.5);
        this._weapon.rotation = 0.5;
        this._weapon.visible = false;
        this.addChild(this._weapon);

        config = P3.assets.json("particle_loot_coins_burst_0");
        this._coinEmitter = new PIXI.particles.Emitter(this._particleLayer, [
            P3.assets.texture("particle_coin_1"),
            P3.assets.texture("particle_coin_2"),
            P3.assets.texture("particle_coin_3")
        ], config);
        this._coinEmitter.emit = false;
        this._coinEmitter.updateOwnerPos(this._glow.x, this._glow.y + 60);

        this.initCrate();
        this.initPanel();

        this.preloadItem();
    }

    destroy() {
        this._coinEmitter.destroy();
        this._orb.emitter.destroy();

        if (this._item) {
            P3.assets.unloadTexture(this._item.images.loot);
        }

        super.destroy();
    }

    resize() {
        super.resize();

        this._overlay.position.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
        this._overlay.width = P3.View.width;
    }

    preloadItem() {
        if (!this._item) {
            this._imageLoaded = true;
            return;
        }

        const manifest = [{name: this._item.images.loot, url: "images/equipment/" + this._item.images.loot + ".png"}];

        const assets = P3.assets;
        const basePath = common.gmi ? common.gmi.gameDir : "./";
        assets.addFiles(manifest, basePath + "assets/");

        this._bindings.progress = assets.signals.progress.add(this.onPreloaderProgress, this);
        this._bindings.complete = assets.signals.complete.once(this.onPreloaderComplete, this);

        assets.load();
    }

    onPreloaderProgress(event) {
        console.log(event.progress);
    }

    onPreloaderComplete(event) {
        this._bindings.progress.detach();
        this._bindings.complete.detach();

        this._image.texture = P3.assets.texture(this._item.images.loot);

        this._imageLoaded = true;

        const settings = common.gmi.getAllSettings();
        if (!settings.motion) {
            this._image.visible = true;
            if (this._item) {
                this._panel.visible = true;
                this._confirmButton.visible = true;
                this._declineButton.visible = true;
            } else {
                P3.utils.delayg(this._tweens, 1, () => {
                    this.signals.previous.dispatch(this);
                });
            }
        }
    }

    appear() {
        super.appear();

        // fade out current music
        const music = P3.audio.music;
        if (music) {
            const t = {value: 1};
            new P3.utils.TWEEN.Tween(t, this._tweens)
                .to({value: 0.3}, 1000)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onUpdate(() => {
                    music.howl.volume(t.value);
                })
                .start();
        }

        P3.audio.playSound(["sfx_loot_crate_reveal_02", "sfx_loot_crate_reveal_03"]);

        if (common.location.training) {
            P3.utils.delayg(this._tweens, 0.4, () => {
                P3.audio.playVO("vo_queen_129", 1, true);
            });
        } else if (this._showOrb) {
            P3.utils.delayg(this._tweens, 0.4, () => {
                P3.audio.playVO("vo_queen_extra_11b12c", 1, true);
            });
        } else {
            P3.utils.delayg(this._tweens, 0.4, () => {
                P3.audio.playVO("vo_queen_130", 1, true);
            });
        }
    }

    animateIn() {
        const settings = common.gmi.getAllSettings();

        if (settings.motion) {
            let to = this._overlay.alpha;
            this._overlay.alpha = 0;
            new P3.utils.TWEEN.Tween(this._overlay, this._tweens)
                .to({alpha: to}, 240)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onStart(() => {
                    this._overlay.visible = true;
                })
                .start();

            this._glow.alpha = 0;
            new P3.utils.TWEEN.Tween(this._glow, this._tweens)
                .to({alpha: 1}, 240)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .delay(240)
                .onStart(() => {
                    this._glow.visible = true;
                })
                .start();

            this._glow.scale.set(3);
            new P3.utils.TWEEN.Tween(this._glow.scale, this._tweens)
                .to({x: 4, y: 4}, 340)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .delay(240)
                .start();

            this._crate.scale.set(0);
            const a = new P3.utils.TWEEN.Tween(this._crate.scale, this._tweens)
                .to({x: 1, y: 1}, 340)
                .easing(P3.utils.TWEEN.Easing.Back.Out)
                .delay(300)
                .onStart(() => {
                    this._crate.visible = true;

                    const to = this._crate.y;
                    this._crate.y += 80;

                    new P3.utils.TWEEN.Tween(this._crate, this._tweens)
                        .to({y: to}, 340)
                        .easing(P3.utils.TWEEN.Easing.Cubic.Out)
                        .start();
                });

            a.start();

            const theta = 0.032;
            const duration = 140;

            // animate lid shake
            const lidTo = this._crate.top.y;
            const lidShake = new P3.utils.TWEEN.Tween(this._crate.top, this._tweens)
                .to({y: this._crate.top.y - 3}, 80)
                .repeat(Infinity)
                .yoyo(true)
                .start();

            // animate shake
            const b = new P3.utils.TWEEN.Tween(this._crate, this._tweens)
                .to({rotation: -theta}, duration * 0.5)
                .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    shakeLoop.call(this, () => {
                        const d = new P3.utils.TWEEN.Tween(this._crate, this._tweens)
                            .to({rotation: 0}, duration * 0.5)
                            .easing(P3.utils.TWEEN.Easing.Quadratic.In)
                            .onComplete(() => {
                                lidShake && lidShake.stop();
                                this._crate.top.y = lidTo;
                            });

                        // pop lid
                        const e = new P3.utils.TWEEN.Tween(this._crate.top.scale, this._tweens)
                            .to({x: 0.84, y: 0.84}, 320)
                            .easing(P3.utils.TWEEN.Easing.Cubic.In)
                            .delay(100)
                            .onStart(() => {
                                new P3.utils.TWEEN.Tween(this._crate.top, this._tweens)
                                    .to({y: this._crate.top.y - 300, alpha: 0}, 320)
                                    .easing(P3.utils.TWEEN.Easing.Cubic.In)
                                    .start();

                                new P3.utils.TWEEN.Tween(this._crate.bottom.scale, this._tweens)
                                    .to({x: 0.8, y: 0.8}, 320)
                                    .easing(P3.utils.TWEEN.Easing.Cubic.In)
                                    .delay(40)
                                    .onStart(() => {
                                        new P3.utils.TWEEN.Tween(this._crate.bottom, this._tweens)
                                            .to({x: 0, y: 400, alpha: 0}, 320)
                                            .easing(P3.utils.TWEEN.Easing.Cubic.In)
                                            .start();

                                        P3.audio.playSound("sfx_lootcrate_open_00");
                                    })
                                    .onComplete(() => {
                                        this._crate.bottom.visible = false;
                                    })
                                    .start();

                                new P3.utils.TWEEN.Tween(this._glow.additive, this._tweens)
                                    .to({alpha: 0.64}, 400)
                                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                                    .repeat(1)
                                    .yoyo(true)
                                    .start();

                                new P3.utils.TWEEN.Tween(this._glow, this._tweens)
                                    .to({alpha: 0}, 600)
                                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                                    .delay(640)
                                    .start();
                            })
                            .onComplete(() => {
                                // we fake unlocking the achievement here, because it is already unlocked earlier!
                                const user = common.save.getUserData(common.userId);
                                this.fakeEquipmentAchievement(user);

                                this._crate.top.visible = false;

                                const to = this._image.y;

                                if (this._showOrb)
                                {
                                    /*
                                    this._orb.y += 120;
                                    new P3.utils.TWEEN.Tween(this._orb, this._tweens)
                                        .to({y: to}, 340)
                                        .easing(P3.utils.TWEEN.Easing.Cubic.Out)
                                        .start();

                                    this._orb.scale.set(0);
                                    new P3.utils.TWEEN.Tween(this._orb.scale, this._tweens)
                                        .to({x: 1, y: 1}, 340)
                                        .easing(P3.utils.TWEEN.Easing.Back.Out)
                                        .onStart(() => {
                                            this._orb.visible = true;
                                            this._coinEmitter.emit = true;
                                        })
                                        .onComplete(() => {
                                            this._orb.emitter.emit = true;
                                        })
                                        .start();

                                    new P3.utils.TWEEN.Tween(this._orb, this._tweens)
                                        .to({alpha: 0}, 240)
                                        .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                                        .delay(2000)
                                        .onComplete(() =>
                                        {
                                            this._orb.visible = false;
                                            this._orb.emitter.emit = false;
                                        })
                                        .start();
                                     */

                                    this._weapon.y += 120;
                                    new P3.utils.TWEEN.Tween(this._weapon, this._tweens)
                                        .to({y: to}, 340)
                                        .easing(P3.utils.TWEEN.Easing.Cubic.Out)
                                        //.delay(2500 + 340)
                                        .delay(340)
                                        .start();

                                    this._weapon.scale.set(0);
                                    new P3.utils.TWEEN.Tween(this._weapon.scale, this._tweens)
                                        .to({x: 1, y: 1}, 340)
                                        .easing(P3.utils.TWEEN.Easing.Back.Out)
                                        //.delay(2500 + 340)
                                        .delay(340)
                                        .onStart(() => {
                                            this._weapon.visible = true;
                                            this._coinEmitter.emit = true;

                                            //P3.audio.playSound("sfx_lootcrate_open_00");
                                        })
                                        .start();

                                    if (this._showItem)
                                    {
                                        new P3.utils.TWEEN.Tween(this._weapon, this._tweens)
                                            .to({alpha: 0}, 240)
                                            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                                            //.delay(2000 + 2500 + 340)
                                            .delay(8000 + 340)
                                            .onComplete(() =>
                                            {
                                                this._weapon.visible = false;
                                            })
                                            .start();
                                    }
                                    else
                                    {
                                        //P3.utils.delayg(this._tweens, 2.5 + 3.5, () => {
                                        P3.utils.delayg(this._tweens, 8.5, () => {
                                            this.signals.previous.dispatch(this);
                                        });
                                    }
                                }

                                if (this._showItem)
                                {
                                    const delay = this._showOrb ? 8000 + 680 : 0;

                                    this._image.y += 120;
                                    new P3.utils.TWEEN.Tween(this._image, this._tweens)
                                        .to({y: to}, 340)
                                        .easing(P3.utils.TWEEN.Easing.Cubic.Out)
                                        .delay(delay)
                                        .start();

                                    this._image.scale.set(0);
                                    new P3.utils.TWEEN.Tween(this._image.scale, this._tweens)
                                        .to({x: 1, y: 1}, 340)
                                        .easing(P3.utils.TWEEN.Easing.Back.Out)
                                        .delay(delay)
                                        .onStart(() => {
                                            this._image.visible = true;
                                            this._coinEmitter.emit = true;

                                            if (this._showOrb)
                                                P3.audio.playSound("sfx_lootcrate_open_00");
                                        })
                                        .start();

                                    if (this._item) {
                                        new P3.utils.TWEEN.Tween(this._panel, this._tweens)
                                            .to({alpha: 1}, 240)
                                            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                                            .delay(delay)
                                            .onStart(() => {
                                                this._panel.visible = true;
                                            })
                                            .start();

                                        const to = this._panel.y;
                                        this._panel.y += 80;
                                        new P3.utils.TWEEN.Tween(this._panel, this._tweens)
                                            .to({y: to}, 340)
                                            .easing(P3.utils.TWEEN.Easing.Cubic.Out)
                                            .delay(delay)
                                            .start();

                                        this._confirmButton.scale.set(0);
                                        new P3.utils.TWEEN.Tween(this._confirmButton.scale, this._tweens)
                                            .to({x: 1, y: 1}, 340)
                                            .easing(P3.utils.TWEEN.Easing.Back.Out)
                                            .delay(260 + delay)
                                            .onStart(() => {
                                                this._confirmButton.interactive = true;
                                                this._confirmButton.visible = true;
                                            })
                                            .start();

                                        this._declineButton.scale.set(0);
                                        new P3.utils.TWEEN.Tween(this._declineButton.scale, this._tweens)
                                            .to({x: 1, y: 1}, 340)
                                            .easing(P3.utils.TWEEN.Easing.Back.Out)
                                            .delay(220 + delay)
                                            .onStart(() => {
                                                this._declineButton.interactive = true;
                                                this._declineButton.visible = true;
                                            })
                                            .start();
                                    } else {
                                        P3.utils.delayg(this._tweens, 2.5 + delay / 1000, () => {
                                            this.signals.previous.dispatch(this);
                                        });
                                    }
                                }
                            });

                        d.chain(e);
                        d.start();
                    });
                });

            // animate shake loop
            function shakeLoop(callback, scope) {
                scope = scope || window;

                new P3.utils.TWEEN.Tween(this._crate, this._tweens)
                    .to({rotation: theta}, duration)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .repeat(3)
                    .yoyo(true)
                    .onComplete(() => {
                        if (!this._imageLoaded) {
                            shakeLoop.call(this, callback, scope);
                        } else {
                            callback && callback.call(scope);
                        }
                    })
                    .start();
            }

            a.chain(b);
            a.start();
        }
    }

    update() {
        super.update();

        const dt = window.dt;
        this._coinEmitter.update(dt);
        this._orb.emitter.update(dt);

        const settings = common.gmi.getAllSettings();
        if (settings.motion) {
            this._orb.back.rotation -= 3 * dt;
            this._orb.front.rotation += 1 * dt;
        }
    }

    initCrate() {
        this._crate = new PIXI.Container();
        this._crate.position.set(common.STAGE_WIDTH * 0.5, P3.View.height * 0.5);
        this._crate.visible = false;
        this.addChild(this._crate);

        this._crate.bottom = new PIXI.Sprite(P3.assets.texture("ui_results_loot_crate_bottom"));
        this._crate.bottom.anchor.set(0.5);
        this._crate.addChild(this._crate.bottom);

        this._crate.top = new PIXI.Sprite(P3.assets.texture("ui_results_loot_crate_top"));
        this._crate.top.anchor.set(0.5);
        this._crate.addChild(this._crate.top);
    }

    initPanel() {
        this._panel = new PIXI.Sprite(P3.assets.texture("ui_results_panel_equip"));
        this._panel.position.set(common.STAGE_WIDTH * 0.5, P3.View.height - 200);
        this._panel.anchor.set(0.5);
        this._panel.visible = false;
        this.addChild(this._panel);

        this._panel.label = new PIXI.extras.BitmapText("Do you want to equip your Guardian with this new item?",
            {font: "34px BBC Reith Sans", align: "center"});
        this._panel.label.position.set(0, -16);
        this._panel.label.anchor.set(0.5);
        this._panel.label.maxWidth = this._panel.texture.width * 0.8;
        this._panel.label.lineHeight = 4;
        this._panel.addChild(this._panel.label);

        this._confirmButton = GelHackButton.create(
            P3.assets.texture("btn_large_normal"),
            P3.assets.texture("btn_large_over"),
            P3.assets.texture("btn_large_down"),
            P3.assets.texture("ui_icon_accept_nongel_medium")
        );
        this._confirmButton.position.set(this._panel.position.x + 120, this._panel.position.y + 88);
        this._confirmButton.visible = false;
        this._confirmButton.signals.click.add(this.onConfirmButtonClick, this);
        this.addChild(this._confirmButton);

        this._declineButton = GelHackButton.create(
            P3.assets.texture("btn_large_normal"),
            P3.assets.texture("btn_large_over"),
            P3.assets.texture("btn_large_down"),
            P3.assets.texture("ui_icon_decline_nongel_medium")
        );
        this._declineButton.position.set(this._panel.position.x - 120, this._panel.position.y + 88);
        this._declineButton.visible = false;
        this._declineButton.signals.click.add(this.onDeclineButtonClick, this);
        this.addChild(this._declineButton);
    }

    onConfirmButtonClick(button) {
        this._confirmButton.enabled = false;
        this._declineButton.enabled = false;

        this.signals.next.dispatch(this);
    }

    onDeclineButtonClick(button) {
        this._confirmButton.enabled = false;
        this._declineButton.enabled = false;

        this.signals.previous.dispatch(this);
    }

    fakeEquipmentAchievement(user)
    {
        const purse = user.unlock["equip_purse"];
        if (Array.isArray(purse))
        {
            if (this._equipmentAchievement === Achievement.UNLOCK_ALL_PURSES)
                common.achievements.unlock(Achievement.UNLOCK_ALL_PURSES, AchievementSystem.SETTING_FORCE_SILENT);
        }

        const belt = user.unlock["equip_belt"];
        if (Array.isArray(belt))
        {
            if (this._equipmentAchievement === Achievement.UNLOCK_ALL_BELTS)
                common.achievements.unlock(Achievement.UNLOCK_ALL_BELTS, AchievementSystem.SETTING_FORCE_SILENT);
        }

        const band = user.unlock["equip_band"];
        if (Array.isArray(band))
        {
            if (this._equipmentAchievement === Achievement.UNLOCK_ALL_BRACELETS)
                common.achievements.unlock(Achievement.UNLOCK_ALL_BRACELETS, AchievementSystem.SETTING_FORCE_SILENT);
        }

        const amulet = user.unlock["equip_amulet"];
        if (Array.isArray(amulet))
        {
            if (this._equipmentAchievement === Achievement.UNLOCK_ALL_AMULETS)
                common.achievements.unlock(Achievement.UNLOCK_ALL_AMULETS, AchievementSystem.SETTING_FORCE_SILENT);
        }

        const feather = user.unlock["equip_feather"];
        if (Array.isArray(feather))
        {
            if (this._equipmentAchievement === Achievement.UNLOCK_ALL_FEATHERS)
                common.achievements.unlock(Achievement.UNLOCK_ALL_FEATHERS, AchievementSystem.SETTING_FORCE_SILENT);
        }

        const cloak = user.unlock["equip_cloakfront,equip_cloakback"];
        if (Array.isArray(cloak))
        {
            if (this._equipmentAchievement === Achievement.UNLOCK_ALL_CLOAKS)
                common.achievements.unlock(Achievement.UNLOCK_ALL_CLOAKS, AchievementSystem.SETTING_FORCE_SILENT);
        }

        const shield = user.unlock["equip_shield"];
        if (Array.isArray(shield))
        {
            if (this._equipmentAchievement === Achievement.UNLOCK_ALL_SHIELDS)
                common.achievements.unlock(Achievement.UNLOCK_ALL_SHIELDS, AchievementSystem.SETTING_FORCE_SILENT);
        }

        const pet = user.unlock["pet"];
        if (Array.isArray(pet))
        {
            if (this._equipmentAchievement === Achievement.UNLOCK_ALL_PETS)
                common.achievements.unlock(Achievement.UNLOCK_ALL_PETS, AchievementSystem.SETTING_FORCE_SILENT);
        }
    }
}